var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('sc-menu',{key:_vm.$route.fullPath,attrs:{"largescreen":_vm.largescreen}}),_c('keep-alive',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"largescreen":_vm.largescreen}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }